'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _flowRight = require('lodash/flowRight');

var _flowRight2 = _interopRequireDefault(_flowRight);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _flowRight2.default;


/*****************
 ** WEBPACK FOOTER
 ** ./~/recompose/compose.js
 ** module id = 2008
 ** module chunks = 0
 **/